/* eslint-disable max-len */
export default {
    state: {
        commonStrings: {},
        sharedStrings: {
            person: {
                name: 'Name'
            },
            generic: {},
            accounts: {
                email_address: 'Email Address',
                username: 'Username',
                password: 'Password'
            },
            address: {},
            forms: {},
            profile: {},
            email_verification: {
                email_verify_card_verify_header: 'VERIFY YOUR EMAIL / USERNAME',
                email_username_update_content: 'In order to improve our site security, your username must be a unique email address. Your username is currently not an email, please update to an email.',
                email_verify_card_verify_content: 'In order to improve our site security, an email address can only be used for one account. Please confirm this email is yours only or edit it.',
                email_verify_card_verify_current_username: 'Current Email / Username',
                email_verify_card_success_header: 'Your email has been verified',
                email_verify_card_verify_button: 'VERIFY YOUR EMAIL / USERNAME',
                email_verify_card_verify_change_button: 'EDIT YOUR EMAIL / USERNAME',
                email_verify_card_info_header: 'You\'ve got mail',
                email_verify_card_success_content: 'Use it to log in next time',
                email_verify_card_info_sent: 'Please check your email to verify your address.',
                email_verify_card_info_modified: 'Your email address has been modified and will now be used as your username. Please check your emails to verify your address',
                email_verify_card_info_resend: 'Resend email verification',
                email_verify_card_info_resend_success: 'A verification email has been sent. This could take a few minutes.',
                email_verify_card_error_header: 'You have an error',
                email_verify_card_error_content: 'Network error',
                edit_email_modal_header: 'Edit your Email / Username',
                email_verify_card_current_email: 'Current Email',
                email_verify_card_current_username: 'Current Username',
                edit_email_modal_new_email_label: 'New Username',
                email_input_username_warning: 'Must be an email address',
                new_email_confirmation_sent: 'A confirmation link will be sent to this new email.',
                email_verification_email_linked_account: 'Your new email address will be linked to this Nu Skin account and will be used as your username.',
                personal_info_email_verified: 'Email Verified',
                personal_info_email_not_verified: 'Email Not Verified'
            },
            shipping_address: {}
        },
        personal: {
            hu_tax_info: {}
        },
        privacy: {},
        address: {},
        categories: {},
        communication: {},
        orderHistory: {},
        directDeposit: {},
        favorites: {},
        payment: {},
        terms: {
            smsTerms: {},
            directDeposit: {
                ddExplantion: {},
                ddTerms: {}
            }
        },
        ...window.translationString
    },
    getters: {
        commonStrings: state => {
            return state.commonStrings
        },
        sharedStrings: state => {
            return state.sharedStrings
        },
        translationsAddress: state => {
            return state.address
        },
        translationsCategories: state => {
            return state.categories
        },
        translationsCommunication: state => {
            return state.communication
        },
        translationsTerms: state => {
            return state.terms.smsTerms
        },
        directDepositExplanationTerms: state => {
            return state.terms.directDeposit.ddExplantion
        },
        directDepositAgreementTerms: state => {
            return state.terms.directDeposit.ddTerms
        },
        translationsDirectDeposit: state => {
            return state.directDeposit
        },
        translationsError: state => {
            return state.error
        },
        translationsFavorites: state => {
            return state.favorites
        },
        translationsGlobal: state => {
            return state.global
        },
        translationsToast: state => {
            return state.emailToast
        },
        translationsOrderHistory: state => {
            return state.orderHistory
        },
        translationsPayment: state => {
            return state.payment
        },
        translationsPersonal: state => {
            return state.personal
        },
        translationsPrivacy: state => {
            let privacy = state.privacy
            if (!privacy.sponsorLabel) {
                privacy.sponsorLabel = 'Sponsor'
                privacy.groupLabel = 'Group Leaders'
                privacy.uplineRepLabel = 'Upline Brand Representatives'
                privacy.orderPrivacyDesc =
          'By checking the box below you are granting your upline with access to your order and subscription details'
                privacy.orderPrivacyEditDesc =
          'By checking the box below you are granting your upline with access to your order and subscription details'
                privacy.orderPrivacyLegal =
          'Your order includes information about your purchases (product name, quantity, volume, price, order tracking, ship to details), as well as Subscription contract details (product name, quantity, price, ship to details). This information is made available by default to your sponsor until you qualify as a Brand Representative. This allows her/him to provide you with product support and training, as well as product recommendations. You can manage who has access to your order information by (un)checking the boxes. You can grant access to additional uplines to enable them to reach out to you for additional support and training.'
            }
            return privacy
        },
        translationsURL: state => {
            return state.urlList
        }
    },
    mutations: {
        setCommonStrings: (state, payload) => {
            state.commonStrings = payload
        },
        setPrivacyStrings: (state, payload) => {
            state.privacy = payload
        },
        setPersonalStrings: (state, payload) => {
            state.personal = payload
        },
        setCategoriesStrings: (state, payload) => {
            state.categories = payload
        },
        setSharedStrings: (state, payload) => {
            state.sharedStrings = payload
        },
        setCommunicationStrings: (state, payload) => {
            state.communication = payload
        },
        setSmsTerms: (state, payload) => {
            state.terms.smsTerms = payload
        },
        setDirectDepositExplanationTerms: (state, payload) => {
            state.terms.directDeposit.ddExplantion = payload
        },
        setDirectDepositAgreementTerms: (state, payload) => {
            state.terms.directDeposit.ddTerms = payload
        },
        setFavoriteStrings: (state, payload) => {
            state.favorites = payload
        },
        setDirectDepositStrings: (state, payload) => {
            state.directDeposit = payload
        },
        setOrderHistoryStrings: (state, payload) => {
            state.orderHistory = payload
        },
        setPaymentMethodStrings: (state, payload) => {
            state.payment = payload
        }
    },
    actions: {
        setCommonStrings: ({ commit }, payload) => {
            commit('setCommonStrings', payload)
        },
        setPrivacyStrings: ({ commit }, payload) => {
            commit('setPrivacyStrings', payload)
        },
        setPersonalStrings: ({ commit }, payload) => {
            commit('setPersonalStrings', payload)
        },
        setCategoriesStrings: ({ commit }, payload) => {
            commit('setCategoriesStrings', payload)
        },
        setSharedStrings: ({ commit }, payload) => {
            commit('setSharedStrings', payload)
        },
        setCommunicationStrings: ({ commit }, payload) => {
            commit('setCommunicationStrings', payload)
        },
        setSmsTerms: ({ commit }, payload) => {
            commit('setSmsTerms', payload)
        },
        setDirectDepositExplanationTerms: ({ commit }, payload) => {
            commit('setDirectDepositExplanationTerms', payload)
        },
        setDirectDepositAgreementTerms: ({ commit }, payload) => {
            commit('setDirectDepositAgreementTerms', payload)
        },
        setFavoriteStrings: ({ commit }, payload) => {
            commit('setFavoriteStrings', payload)
        },
        setDirectDepositStrings: ({ commit }, payload) => {
            commit('setDirectDepositStrings', payload)
        },
        setOrderHistoryStrings: ({ commit }, payload) => {
            commit('setOrderHistoryStrings', payload)
        },
        setPaymentMethodStrings: ({ commit }, payload) => {
            commit('setPaymentMethodStrings', payload)
        }
    }
}